import { isPacketFormComplete } from './parentPacketNavigation';

export function packetDraftStorageKey(token, formId) {
  return `packet_draft_${token}_${formId}`;
}

export function hasPacketFormDraft(token, formId) {
  if (!token || !formId) return false;
  try {
    const raw = localStorage.getItem(packetDraftStorageKey(token, formId));
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return parsed != null && typeof parsed.formState === 'object';
  } catch {
    return false;
  }
}

/** complete | in_progress | not_started */
export function getPacketFormIndexStatus(form, { token, formId }) {
  if (isPacketFormComplete(form)) return 'complete';
  if (hasPacketFormDraft(token, formId)) return 'in_progress';
  return 'not_started';
}

export function getPacketFormIndexActionLabel(status) {
  switch (status) {
    case 'complete':
      return 'Edit';
    case 'in_progress':
      return 'Resume';
    default:
      return 'Start';
  }
}
